import React from "react";
import { useNavigate } from "react-router-dom";

import { ClaimedBusiness } from "store/useAuthStore";

// components
import {
  Dialog,
  DialogContent,
  Button,
  RoundedButton,
} from "components/LibraryComponents/Components";

// styles
import styles from "./VerifiedBusinessesDialog.module.scss";

type VerifiedBusinessesDialogProps = {
  businessess: ClaimedBusiness[];
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function VerifiedBusinessesDialog(
  props: VerifiedBusinessesDialogProps
) {
  const navigate = useNavigate();

  const handleEdit = (business: ClaimedBusiness) => {
    navigate(`/profile/${business.uei}/${business.cage_codes[0]}/edit`);
  };

  return (
    <Dialog
      open={props.open}
      onOpenChange={props.setOpen}
      dismissOutsideClick={false}
    >
      <DialogContent
        className={styles["verified-dialog-root"]}
        hasBackdrop
        lockScroll
      >
        <div className={styles["verified-dialog-body"]}>
          <div className={styles["verified-content"]}>
            <ul className={styles["list"]}>
              {props.businessess.map((biz) => (
                <li key={biz.uei} className={styles["item"]}>
                  <p>{biz.legal_business_name}</p>
                  <RoundedButton
                    variant="ghost"
                    onClick={() => handleEdit(biz)}
                  >
                    Edit
                  </RoundedButton>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles["verified-dialog-footer"]}>
          <Button
            type="button"
            className={styles["btn"]}
            aria-label="Back to advanced search"
          >
            Back to advanced search
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
